/** Ouvre une modale generique (overlay + carte parchemin) et retourne un moyen de la fermer. */
export function openModal(cardContent: HTMLElement, options: { dismissible?: boolean } = {}): { close: () => void; overlay: HTMLDivElement } {
  const overlay = document.createElement("div");
  overlay.className = "modal-overlay interactive";

  const card = document.createElement("div");
  card.className = "modal-card ornate-panel";
  card.appendChild(cardContent);
  overlay.appendChild(card);

  if (options.dismissible !== false) {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) close();
    });
  }

  document.getElementById("ui-root")?.appendChild(overlay);

  function close() {
    overlay.remove();
  }

  return { close, overlay };
}
